<template>
    <div>
      <v-btn color="primary" dark class="mb-2 hbtn" to="/restaurants/store"
        >{{ $t("restaurantsPage.newRestaurant") }}</v-btn
      >
      <DataTable
        ref="restaurantDataTable"
        :url="api.ACTIONS.RESTAURANT"
        :titles="titles"
        :fields-hidden-add="['created_at', 'updated_at']"
        :title='$t("restaurantsPage.pageTitle")'
        :enableEdit="false"
        :enableAdd="false"
        :enableDelete="false"
        :add-rules="rules"
        :actions-extra-main="actionsExtraMain"
      />
    </div>
  </template>
  
  <style>
  .hbtn {
    float: inline-end;
    z-index: 1;
    margin-top: 20px;
    margin-inline-end: 20px;
    padding: 0px 45px;
  }
  </style>
  
  <script>
  import DataTable from "@/components/monaco/DataTable";
  import moment from "moment";

  export default {
    name: "Restaurants",
    title: "restaurantsPage.pageTitle",
    components: { DataTable },
    data() {
      return {};
    },

    computed: {
      rules() {
        const required = (val) =>
          (val !== null && val !== undefined) ||
          this.$t("restaurantsPage.fieldRequired");
        return {
          name: [required],
        };
      },
      titles() {
        return {
          id: this.$t("restaurantsPage.colId"),
          name: this.$t("restaurantsPage.colName"),
          address: this.$t("restaurantsPage.colAddress"),
          landmark: this.$t("restaurantsPage.colLandmark"),
        };
      },
      actionsExtraMain() {
        return {
          editRestaurant: {
            title: this.$t("restaurantsPage.editRestaurant"),
            icon: "edit",
            action: (item) =>
              this.$router.push({
                name: "EditRestaurant",
                params: { id: item.id },
              }),
          },
          deleteRestaurant: {
            title: this.$t("restaurantsPage.deleteRestaurant"),
            icon: "delete_forever",
            action: ({ id }) => {
              this.loading = true;
              this.axios
                .delete(`restaurant/${id}`)
                .then((res) => {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("restaurantsPage.restaurantDeleted"),
                    "green"
                  );
                  this.$refs.restaurantDataTable.getData();
                })
                .catch((err) => {
                  let response = err.response;
                  if (response) {
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      response.data.message,
                      "red"
                    );
                  } else {
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      this.$t("restaurantsPage.somethingWentWrong"),
                      "red"
                    );
                  }
                })
                .finally(() => (this.loading = false));
            },
          },
        };
      },
    },
  };
  </script>
  